module.exports = __webpack_public_path__ + "static/media/Thailand.4b554bf2.png";